import { FC, useEffect } from 'react'

import {
  env,
  QWIK_RETURN_URL,
  TRAVEL_RETURN_URL,
  VALUT_RETURN_URL,
} from '@utils'

import { SESSION_PRODUCT_KEY } from '../../../../stores/payform/payForm'
import { EProduct } from '../../../../stores/types/EProduct'

const productUrls: Record<EProduct, string> = {
  [EProduct.QWIK]: QWIK_RETURN_URL,
  [EProduct.VALUT]: VALUT_RETURN_URL,
  [EProduct.TRAVEL_CARDS]: TRAVEL_RETURN_URL,
}

export const ClosePage: FC = () => {
  useEffect(() => {
    const product = sessionStorage.getItem(SESSION_PRODUCT_KEY) as EProduct
    const successUrl = sessionStorage.successUrl

    location.assign(successUrl || env(productUrls[product]))
  }, [])

  return <></>
}
